module.exports = __webpack_public_path__ + "img/gemini-color.738fc287.svg";